"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRtl = void 0;
var _browser = require("./browser");
const isRtl = element => {
  if (!(0, _browser.isBrowser)()) {
    return false;
  }
  return (element !== null && element !== void 0 ? element : document.documentElement).dir === 'rtl';
};
exports.isRtl = isRtl;